export function serializeObjectToParams(params: any) {
  if (typeof params !== 'object') {
    return '';
  }

  return `?${Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&')}`;
}
